import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'investment_name', label: 'Investment' },
  { key: 'investment_code', label: 'Code' },
  { key: 'type', label: 'Type' },
  { key: 'income_date', label: 'Expected Date' },
  { key: 'expected_amount', label: 'Expected Amount', align: 'right', type: 'money' },
  { key: 'days_outstanding', label: 'Days Outstanding', align: 'right' },
  { key: 'bucket', label: 'Bucket' },
];

export function IncomeVsExpectedReport() {
  return (
    <ReportView
      title="Income vs Expected"
      description="Investment income not yet received, bucketed by days overdue (current, 1-30, 31-60, 61-90, 91-120, 120+)."
      endpoint="/reports/investments/income-vs-expected"
      columns={COLUMNS}
      defaultSort="days_outstanding"
      xlsx
    />
  );
}
